export const StoreStatus = ["Inactive:0", "Active:1"]

export const CashierStatus = ["Inactive:0", "Active:1"]